export default {
  title: 'Aanbiedingsafbeelding',
  select: {
    generate_title: 'Genereer een afbeelding met AI',
    generate_subtitle: 'We maken er één op basis van uw aanbiedingsdetails.',
    generate_cta: 'Genereren',
    upload_link: 'of upload vanaf uw apparaat',
    rate_limit_company: {
      title: 'Even een moment',
      description: 'Uw restaurant heeft dit uur veel afbeeldingen gegenereerd. Probeer opnieuw over {{time}}.',
    },
    rate_limit_offer: {
      title: 'Even op adem komen',
      description: 'U heeft deze aanbieding een paar keer achter elkaar geprobeerd. We zijn over {{time}} weer klaar.',
    },
  },
  generating: {
    title: 'Uw afbeelding wordt gegenereerd…',
    progress: {
      cooking: 'Iets lekkers aan het bereiden…',
      plating: 'Aanrichten…',
      finishing: 'De laatste hand leggen…',
    },
  },
  preview: {
    alt: 'Gegenereerde aanbiedingsafbeelding',
    hint: 'Niet helemaal goed? Regenereer, of ga door met bijsnijden.',
    click_to_expand: 'Klik om te vergroten',
    regenerate: 'Regenereren',
    continue: 'Doorgaan met bewerken',
  },
  toasts: {
    upload_success: 'Afbeelding succesvol geüpload.',
    upload_failed: 'Uploaden van afbeelding mislukt.',
    delete_success: 'Afbeelding succesvol verwijderd.',
    delete_failed: 'Verwijderen van afbeelding mislukt.',
    generate_success: 'Afbeelding succesvol gegenereerd.',
    generate_failed: 'Starten van afbeeldingsgeneratie mislukt.',
    generate_timeout: 'De afbeelding wordt nog gegenereerd. Deze verschijnt hier zodra het klaar is.',
    rate_limit_company: 'Uurlimiet voor afbeeldingen bereikt voor dit restaurant. Probeer opnieuw over {{time}}.',
    rate_limit_offer: 'Te veel pogingen voor deze aanbieding — probeer opnieuw over {{time}}.',
  },
  time: {
    seconds_one: '1 seconde',
    seconds_other: '{{count}} seconden',
    minutes_one: '1 minuut',
    minutes_other: '{{count}} minuten',
    hours_one: '1 uur',
    hours_other: '{{count}} uur',
  },
};
